var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99.733,
    height: 88,
    viewBox: "0 0 99.733 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1noz62onwa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H99.733V88H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1noz62onwa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f4a802",
    d: "M-5710.419-16235.4h-79.162a9.894 9.894 0 0 1-8.672-5.021 9.9 9.9 0 0 1 .04-10.023l39.577-67.769a9.9 9.9 0 0 1 8.636-4.959 9.9 9.9 0 0 1 8.637 4.959l39.577 67.769a9.9 9.9 0 0 1 .04 10.023 9.9 9.9 0 0 1-8.673 5.021zm-39.581-22a4.4 4.4 0 0 0-4.4 4.4 4.4 4.4 0 0 0 4.4 4.4 4.405 4.405 0 0 0 4.4-4.4 4.405 4.405 0 0 0-4.4-4.4zm0-38.135a4.4 4.4 0 0 0-4.4 4.4v24.2a4.4 4.4 0 0 0 4.4 4.4 4.405 4.405 0 0 0 4.4-4.4v-24.2a4.405 4.405 0 0 0-4.4-4.401z",
    transform: "translate(5799.867 16323.4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon-alert.93ef61da94ffd32f8b8e334916551133.svg";
export { ForwardRef as ReactComponent };